/**
 * eTwinning badge — pill with the official wordmark image.
 * Renders as an external link to the project's eTwinning page.
 */
export default function EtwinningBadge({ href, variant = "light", className = "", showLabel = true }) {
    const target = href || "https://school-education.ec.europa.eu/en/etwinning";
    const dark = variant === "dark";
    return (
        <a
            href={target}
            target="_blank"
            rel="noreferrer noopener"
            data-testid="etwinning-badge"
            className={`inline-flex items-center gap-2.5 rounded-full border ${
                dark
                    ? "border-white/25 bg-white/10 backdrop-blur-md hover:bg-white/15 text-white"
                    : "border-black/10 bg-white hover:bg-bg-alt text-ink-secondary"
            } px-3 py-1.5 transition-colors duration-300 ${className}`}
        >
            <img
                src="/images/etwinning-logo.png"
                alt="eTwinning"
                className={`h-5 w-auto object-contain ${dark ? "brightness-0 invert" : ""}`}
            />
            {showLabel && (
                <span className="text-[11px] uppercase tracking-[0.18em] font-semibold">
                    eTwinning Project
                </span>
            )}
        </a>
    );
}
